import { render, staticRenderFns } from "./DocumentExporterModal.vue?vue&type=template&id=4b16f6ea&scoped=true&"
import script from "./DocumentExporterModal.vue?vue&type=script&lang=js&"
export * from "./DocumentExporterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b16f6ea",
  null
  
)

export default component.exports